<template>
    <v-container>
    <h1>List groups</h1>
    <my-group-list/>
    </v-container>
</template>

<script>
export default {
    components: {
    'my-group-list': () => import ('@/components/GroupList'),
    
    
  },

}
</script>

<style>

</style>
